const translations = {
  en: {
    // Nav & Common
    home: "Home", services: "Services", howItWorks: "How It Works", trips: "Trips",
    ourStory: "Our Story", signIn: "Sign In", signUp: "Sign Up", logout: "Logout",
    dashboard: "Dashboard", bookRide: "Book Ride", myRides: "My Rides", wallet: "Wallet",
    referEarn: "Refer & Earn", history: "History", support: "Support", profile: "Profile",
    rides: "Rides", drivers: "Drivers", users: "Users", walletPayments: "Wallet & Payments",
    tickets: "Support Tickets", serviceTypes: "Services", reports: "Reports", analytics: "Analytics",
    messages: "Messages", earnings: "Earnings",
    // Dashboard
    welcomeBack: "Welcome back", readyForRide: "Ready for your next ride?",
    totalRides: "Total Rides", active: "Active", loyaltyPoints: "Loyalty Points",
    quickBook: "Quick Book", bookARide: "Book a Ride", noActiveRides: "No active rides",
    // Booking
    serviceType: "Service Type", fromDestination: "From Destination", toDestination: "To Destination",
    selectOrigin: "Select origin", selectDestination: "Select destination",
    estimatedFare: "Estimated Fare", pickupLocation: "Pickup Location", dropLocation: "Drop Location",
    enterPickup: "Enter pickup location", enterDrop: "Enter drop location",
    confirmBooking: "Confirm Booking", booking: "Booking...",
    // Wallet
    myWallet: "My Wallet", availableBalance: "Available Balance", rechargeWallet: "Recharge Wallet",
    addMoney: "Submit Recharge Request", transactions: "Transactions", noTransactions: "No transactions",
    pendingApproval: "Pending Approval", rejected: "Rejected",
    upiTransactionRef: "UPI Transaction ID / Reference", bankTransferRef: "Bank transfer reference",
    payAfterNote: "After paying, enter the transaction reference and submit. Admin will verify and credit your wallet.",
    // Referral
    inviteFriends: "Invite friends & both get", shareCode: "Share your referral code with friends.",
    yourReferralCode: "Your Referral Code", copy: "Copy", copied: "Copied",
    friendsReferred: "Friends Referred", totalEarned: "Total Earned", shareWithFriends: "Share with Friends",
    // Rides
    activeRides: "Active Rides", rideHistory: "Ride History", noPastRides: "No past rides",
    cancelRide: "Cancel", payNow: "Pay", invoice: "Invoice", rate: "Rate", chat: "Chat",
    // Payment
    payForRide: "Pay for Ride", amount: "Amount", paymentMethod: "Payment Method",
    payViaUpi: "Pay via UPI", payAfterRide: "Pay after ride", balance: "Balance",
    // Tickets
    supportTickets: "Support Tickets", newTicket: "New Ticket", createTicket: "Create Support Ticket",
    category: "Category", subject: "Subject", message: "Message", submit: "Submit",
    general: "General", rideIssue: "Ride Issue", payment: "Payment", refund: "Refund", other: "Other",
    typeReply: "Type a reply...", noTickets: "No tickets yet",
    // Profile
    myProfile: "My Profile", edit: "Edit", save: "Save", name: "Name", email: "Email", phone: "Phone",
    savedAddresses: "Saved Addresses", totalSpent: "Total Spent",
    // Notifications
    notifications: "Notifications", noNotifications: "No notifications",
    // Rating
    rateYourRide: "Rate Your Ride", writeReview: "Write a review (optional)", submitRating: "Submit Rating",
    // Admin
    manageRides: "Manage Rides", addDriver: "Add Driver", pending: "Pending",
    totalRevenue: "Total Revenue", activeDrivers: "Active Drivers",
    // Analytics
    rideAnalytics: "Ride Analytics", revenueChart: "Revenue Trends", userGrowth: "User Growth",
    serviceBreakdown: "Service Breakdown", driverPerformance: "Driver Performance",
    completedRides: "Completed Rides", cancelledRides: "Cancelled Rides",
    openTickets: "Open Tickets", totalWalletBalance: "Total Wallet Balance",
    totalReferrals: "Total Referrals", signups: "Signups",
    // Auth
    welcomeBackAuth: "Welcome back", signInToContinue: "Sign in to continue your journey",
    phoneNumber: "Phone Number", password: "Password", enterPhone: "Enter phone number",
    enterPassword: "Enter password", dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?", createAccount: "Create your account",
    joinTheRide: "Join the ride across the valley",
    fullName: "Full Name", emailOptional: "Email (Optional)", referralCode: "Referral Code (Optional)",
    enterReferralCode: "Enter referral code", referralBonus: "You & your friend both get \u20B9100!",
    // Language
    language: "Language", english: "English", hindi: "Hindi", urdu: "Urdu", kashmiri: "Kashmiri",
  },
  hi: {
    home: "होम", services: "सेवाएं", howItWorks: "कैसे काम करता है", trips: "यात्राएं",
    ourStory: "हमारी कहानी", signIn: "लॉग इन", signUp: "साइन अप", logout: "लॉग आउट",
    dashboard: "डैशबोर्ड", bookRide: "राइड बुक करें", myRides: "मेरी राइड्स", wallet: "वॉलेट",
    referEarn: "रेफर करें और कमाएं", history: "इतिहास", support: "सहायता", profile: "प्रोफ़ाइल",
    rides: "राइड्स", drivers: "ड्राइवर", users: "उपयोगकर्ता", walletPayments: "वॉलेट और भुगतान",
    tickets: "सहायता टिकट", serviceTypes: "सेवाएं", reports: "रिपोर्ट", analytics: "एनालिटिक्स",
    messages: "संदेश", earnings: "कमाई",
    welcomeBack: "वापसी पर स्वागत है", readyForRide: "अगली राइड के लिए तैयार?",
    totalRides: "कुल राइड्स", active: "सक्रिय", loyaltyPoints: "लॉयल्टी पॉइंट्स",
    quickBook: "क्विक बुक", bookARide: "राइड बुक करें", noActiveRides: "कोई सक्रिय राइड नहीं",
    serviceType: "सेवा प्रकार", fromDestination: "कहाँ से", toDestination: "कहाँ तक",
    selectOrigin: "प्रारंभ चुनें", selectDestination: "गंतव्य चुनें",
    estimatedFare: "अनुमानित किराया", pickupLocation: "पिकअप स्थान", dropLocation: "ड्रॉप स्थान",
    enterPickup: "पिकअप स्थान दर्ज करें", enterDrop: "ड्रॉप स्थान दर्ज करें",
    confirmBooking: "बुकिंग की पुष्टि करें", booking: "बुक हो रहा है...",
    myWallet: "मेरा वॉलेट", availableBalance: "उपलब्ध शेष", rechargeWallet: "वॉलेट रिचार्ज",
    addMoney: "रिचार्ज अनुरोध भेजें", transactions: "लेनदेन", noTransactions: "कोई लेनदेन नहीं",
    pendingApproval: "अनुमोदन लंबित", rejected: "अस्वीकृत",
    upiTransactionRef: "UPI लेनदेन ID / संदर्भ", bankTransferRef: "बैंक ट्रांसफर संदर्भ",
    payAfterNote: "भुगतान करने के बाद, लेनदेन संदर्भ दर्ज करें। एडमिन सत्यापित करेगा।",
    inviteFriends: "दोस्तों को आमंत्रित करें, दोनों को मिलेंगे", shareCode: "अपना रेफरल कोड दोस्तों के साथ साझा करें।",
    yourReferralCode: "आपका रेफरल कोड", copy: "कॉपी", copied: "कॉपी हो गया",
    friendsReferred: "रेफर किए गए दोस्त", totalEarned: "कुल कमाई", shareWithFriends: "दोस्तों के साथ साझा करें",
    activeRides: "सक्रिय राइड्स", rideHistory: "राइड इतिहास", noPastRides: "कोई पिछली राइड नहीं",
    cancelRide: "रद्द करें", payNow: "भुगतान", invoice: "बिल", rate: "रेटिंग", chat: "चैट",
    payForRide: "राइड के लिए भुगतान", amount: "राशि", paymentMethod: "भुगतान विधि",
    payViaUpi: "UPI से भुगतान", payAfterRide: "राइड के बाद भुगतान", balance: "शेष",
    supportTickets: "सहायता टिकट", newTicket: "नया टिकट", createTicket: "सहायता टिकट बनाएं",
    category: "श्रेणी", subject: "विषय", message: "संदेश", submit: "भेजें",
    general: "सामान्य", rideIssue: "राइड समस्या", payment: "भुगतान", refund: "रिफंड", other: "अन्य",
    typeReply: "जवाब लिखें...", noTickets: "कोई टिकट नहीं",
    myProfile: "मेरी प्रोफ़ाइल", edit: "संपादित करें", save: "सहेजें", name: "नाम", email: "ईमेल", phone: "फ़ोन",
    savedAddresses: "सहेजे गए पते", totalSpent: "कुल खर्च",
    notifications: "सूचनाएं", noNotifications: "कोई सूचना नहीं",
    rateYourRide: "अपनी राइड रेट करें", writeReview: "समीक्षा लिखें (वैकल्पिक)", submitRating: "रेटिंग भेजें",
    manageRides: "राइड्स प्रबंधित करें", addDriver: "ड्राइवर जोड़ें", pending: "लंबित",
    totalRevenue: "कुल राजस्व", activeDrivers: "सक्रिय ड्राइवर",
    rideAnalytics: "राइड एनालिटिक्स", revenueChart: "राजस्व रुझान", userGrowth: "उपयोगकर्ता वृद्धि",
    serviceBreakdown: "सेवा विश्लेषण", driverPerformance: "ड्राइवर प्रदर्शन",
    completedRides: "पूरी हुई राइड्स", cancelledRides: "रद्द राइड्स",
    openTickets: "खुले टिकट", totalWalletBalance: "कुल वॉलेट शेष",
    totalReferrals: "कुल रेफरल", signups: "साइन अप",
    welcomeBackAuth: "वापसी पर स्वागत है", signInToContinue: "अपनी यात्रा जारी रखने के लिए साइन इन करें",
    phoneNumber: "फ़ोन नंबर", password: "पासवर्ड", enterPhone: "फ़ोन नंबर दर्ज करें",
    enterPassword: "पासवर्ड दर्ज करें", dontHaveAccount: "खाता नहीं है?",
    alreadyHaveAccount: "पहले से खाता है?", createAccount: "अपना खाता बनाएं",
    joinTheRide: "वैली की यात्रा में शामिल हों",
    fullName: "पूरा नाम", emailOptional: "ईमेल (वैकल्पिक)", referralCode: "रेफरल कोड (वैकल्पिक)",
    enterReferralCode: "रेफरल कोड दर्ज करें", referralBonus: "आप और आपके दोस्त दोनों को ₹100 मिलेंगे!",
    language: "भाषा", english: "अंग्रेजी", hindi: "हिंदी", urdu: "उर्दू", kashmiri: "कश्मीरी",
  },
  ur: {
    home: "ہوم", services: "خدمات", howItWorks: "یہ کیسے کام کرتا ہے", trips: "سفر",
    ourStory: "ہماری کہانی", signIn: "سائن ان", signUp: "سائن اپ", logout: "لاگ آؤٹ",
    dashboard: "ڈیش بورڈ", bookRide: "سواری بک کریں", myRides: "میری سواریاں", wallet: "والیٹ",
    referEarn: "ریفر کریں اور کمائیں", history: "تاریخ", support: "مدد", profile: "پروفائل",
    rides: "سواریاں", drivers: "ڈرائیور", users: "صارفین", walletPayments: "والیٹ اور ادائیگی",
    tickets: "مدد ٹکٹ", serviceTypes: "خدمات", reports: "رپورٹس", analytics: "تجزیات",
    messages: "پیغامات", earnings: "آمدنی",
    welcomeBack: "خوش آمدید", readyForRide: "اگلی سواری کے لیے تیار؟",
    totalRides: "کل سواریاں", active: "فعال", loyaltyPoints: "لائلٹی پوائنٹس",
    quickBook: "فوری بکنگ", bookARide: "سواری بک کریں", noActiveRides: "کوئی فعال سواری نہیں",
    serviceType: "سروس کی قسم", fromDestination: "کہاں سے", toDestination: "کہاں تک",
    selectOrigin: "اصل مقام منتخب کریں", selectDestination: "منزل منتخب کریں",
    estimatedFare: "تخمینی کرایہ", pickupLocation: "پک اپ مقام", dropLocation: "ڈراپ مقام",
    enterPickup: "پک اپ مقام درج کریں", enterDrop: "ڈراپ مقام درج کریں",
    confirmBooking: "بکنگ کی تصدیق", booking: "بک ہو رہا ہے...",
    myWallet: "میرا والیٹ", availableBalance: "دستیاب بیلنس", rechargeWallet: "والیٹ ریچارج",
    addMoney: "ریچارج کی درخواست بھیجیں", transactions: "لین دین", noTransactions: "کوئی لین دین نہیں",
    pendingApproval: "منظوری زیر التوا", rejected: "مسترد",
    upiTransactionRef: "UPI ٹرانزیکشن ID", bankTransferRef: "بینک ٹرانسفر حوالہ",
    payAfterNote: "ادائیگی کے بعد ٹرانزیکشن حوالہ درج کریں۔ ایڈمن تصدیق کرے گا۔",
    inviteFriends: "دوستوں کو مدعو کریں، دونوں کو ملیں گے", shareCode: "اپنا ریفرل کوڈ دوستوں کے ساتھ شیئر کریں۔",
    yourReferralCode: "آپ کا ریفرل کوڈ", copy: "کاپی", copied: "کاپی ہو گیا",
    friendsReferred: "ریفر کیے گئے دوست", totalEarned: "کل کمائی", shareWithFriends: "دوستوں کے ساتھ شیئر کریں",
    activeRides: "فعال سواریاں", rideHistory: "سواری کی تاریخ", noPastRides: "کوئی پچھلی سواری نہیں",
    cancelRide: "منسوخ", payNow: "ادائیگی", invoice: "بل", rate: "درجہ بندی", chat: "چیٹ",
    payForRide: "سواری کی ادائیگی", amount: "رقم", paymentMethod: "ادائیگی کا طریقہ",
    payViaUpi: "UPI سے ادائیگی", payAfterRide: "سواری کے بعد ادائیگی", balance: "بیلنس",
    supportTickets: "مدد ٹکٹ", newTicket: "نیا ٹکٹ", createTicket: "مدد ٹکٹ بنائیں",
    category: "زمرہ", subject: "موضوع", message: "پیغام", submit: "بھیجیں",
    general: "عام", rideIssue: "سواری مسئلہ", payment: "ادائیگی", refund: "واپسی", other: "دیگر",
    typeReply: "جواب لکھیں...", noTickets: "کوئی ٹکٹ نہیں",
    myProfile: "میرا پروفائل", edit: "ترمیم", save: "محفوظ کریں", name: "نام", email: "ای میل", phone: "فون",
    savedAddresses: "محفوظ پتے", totalSpent: "کل خرچ",
    notifications: "اطلاعات", noNotifications: "کوئی اطلاع نہیں",
    rateYourRide: "اپنی سواری کی درجہ بندی کریں", writeReview: "جائزہ لکھیں (اختیاری)", submitRating: "درجہ بندی بھیجیں",
    manageRides: "سواریاں منظم کریں", addDriver: "ڈرائیور شامل کریں", pending: "زیر التوا",
    totalRevenue: "کل آمدنی", activeDrivers: "فعال ڈرائیور",
    rideAnalytics: "سواری تجزیات", revenueChart: "آمدنی رجحانات", userGrowth: "صارف اضافہ",
    serviceBreakdown: "سروس تجزیہ", driverPerformance: "ڈرائیور کارکردگی",
    completedRides: "مکمل سواریاں", cancelledRides: "منسوخ سواریاں",
    openTickets: "کھلے ٹکٹ", totalWalletBalance: "کل والیٹ بیلنس",
    totalReferrals: "کل ریفرل", signups: "سائن اپ",
    welcomeBackAuth: "خوش آمدید", signInToContinue: "اپنا سفر جاری رکھنے کے لیے سائن ان کریں",
    phoneNumber: "فون نمبر", password: "پاس ورڈ", enterPhone: "فون نمبر درج کریں",
    enterPassword: "پاس ورڈ درج کریں", dontHaveAccount: "اکاؤنٹ نہیں ہے؟",
    alreadyHaveAccount: "پہلے سے اکاؤنٹ ہے؟", createAccount: "اپنا اکاؤنٹ بنائیں",
    joinTheRide: "وادی کے سفر میں شامل ہوں",
    fullName: "پورا نام", emailOptional: "ای میل (اختیاری)", referralCode: "ریفرل کوڈ (اختیاری)",
    enterReferralCode: "ریفرل کوڈ درج کریں", referralBonus: "آپ اور آپ کے دوست دونوں کو ₹100 ملیں گے!",
    language: "زبان", english: "انگریزی", hindi: "ہندی", urdu: "اردو", kashmiri: "کشمیری",
  },
  ks: {
    home: "ہوم", services: "خدمات", howItWorks: "یہ کتھ کام کرِ", trips: "سفر",
    ourStory: "ساونٹ کہانی", signIn: "سائن اِن", signUp: "سائن اَپ", logout: "لاگ آؤٹ",
    dashboard: "ڈیش بورڈ", bookRide: "سواری بُک کرِو", myRides: "میانہ سواریاں", wallet: "والیٹ",
    referEarn: "ریفر کرِو تہِ کمایِو", history: "تاریخ", support: "مدد", profile: "پروفائل",
    rides: "سواریاں", drivers: "ڈرائیور", users: "صارف", walletPayments: "والیٹ تہ ادائیگی",
    tickets: "مدد ٹکٹ", serviceTypes: "خدمات", reports: "رِپورٹ", analytics: "تجزیات",
    messages: "پیغام", earnings: "کمائی",
    welcomeBack: "خوش آمدید", readyForRide: "اگلہِ سواری باپتھ تیار؟",
    totalRides: "کُل سواریاں", active: "فعال", loyaltyPoints: "لائلٹی پوائنٹ",
    quickBook: "فوری بکنگ", bookARide: "سواری بُک کرِو", noActiveRides: "کانہہ فعال سواری نہ",
    serviceType: "سروس قِسم", fromDestination: "کتھ کن", toDestination: "کتھ پیٹھ",
    selectOrigin: "جاے منتخب کرِو", selectDestination: "منزل منتخب کرِو",
    estimatedFare: "تخمینی کرایہ", pickupLocation: "پِک اَپ جاے", dropLocation: "ڈراپ جاے",
    enterPickup: "پِک اَپ جاے درج کرِو", enterDrop: "ڈراپ جاے درج کرِو",
    confirmBooking: "بکنگ تصدیق", booking: "بُک بنان...",
    myWallet: "میون والیٹ", availableBalance: "دستیاب بیلنس", rechargeWallet: "والیٹ ریچارج",
    addMoney: "ریچارج درخواست بھیجِو", transactions: "لین دین", noTransactions: "کانہہ لین دین نہ",
    pendingApproval: "منظوری زیرِ التوا", rejected: "مسترد",
    inviteFriends: "دوستن ہنز دعوت دِیِو، دوشونے ملِ", shareCode: "پنن ریفرل کوڈ دوستن سِتی شیئر کرِو۔",
    yourReferralCode: "تہنز ریفرل کوڈ", copy: "کاپی", copied: "کاپی گوو",
    friendsReferred: "ریفر شدہ دوست", totalEarned: "کُل کمائی", shareWithFriends: "دوستن سِتی شیئر کرِو",
    activeRides: "فعال سواریاں", rideHistory: "سواری تاریخ", noPastRides: "کانہہ پرانی سواری نہ",
    cancelRide: "منسوخ", payNow: "ادائیگی", invoice: "بل", rate: "درجہ", chat: "چیٹ",
    myProfile: "میون پروفائل", edit: "ترمیم", save: "محفوظ", name: "ناو", email: "ای میل", phone: "فون",
    savedAddresses: "محفوظ پتہ", notifications: "اطلاعات", noNotifications: "کانہہ اطلاع نہ",
    language: "زبان", english: "انگریزی", hindi: "ہندی", urdu: "اردو", kashmiri: "کٲشُر",
    // Fallback to Urdu for remaining keys
    payForRide: "سواری ادائیگی", amount: "رقم", paymentMethod: "ادائیگی طریقہ",
    payViaUpi: "UPI ادائیگی", payAfterRide: "سواری بعد ادائیگی", balance: "بیلنس",
    supportTickets: "مدد ٹکٹ", newTicket: "نوو ٹکٹ", createTicket: "مدد ٹکٹ بنایِو",
    category: "زمرہ", subject: "موضوع", message: "پیغام", submit: "بھیجِو",
    general: "عام", rideIssue: "سواری مسئلہ", payment: "ادائیگی", refund: "واپسی", other: "بیاکھ",
    typeReply: "جواب لیکھِو...", noTickets: "کانہہ ٹکٹ نہ",
    rateYourRide: "پنُن سواری ریٹ کرِو", writeReview: "جائزہ لیکھِو", submitRating: "ریٹنگ بھیجِو",
    totalRevenue: "کُل آمدنی", totalSpent: "کُل خرچ",
    rideAnalytics: "سواری تجزیات", revenueChart: "آمدنی رجحان", userGrowth: "صارف اضافہ",
    serviceBreakdown: "سروس تجزیہ", driverPerformance: "ڈرائیور کارکردگی",
    completedRides: "مکمل سواریاں", cancelledRides: "منسوخ سواریاں",
    openTickets: "کھلہِ ٹکٹ", totalWalletBalance: "کُل والیٹ بیلنس", totalReferrals: "کُل ریفرل",
    welcomeBackAuth: "خوش آمدید", signInToContinue: "سفر جاری رکھنے باپتھ سائن اِن کرِو",
    phoneNumber: "فون نمبر", password: "پاس ورڈ", enterPhone: "فون نمبر درج کرِو",
    enterPassword: "پاس ورڈ درج کرِو", dontHaveAccount: "اکاؤنٹ نہ؟",
    alreadyHaveAccount: "اکاؤنٹ چھُ؟", createAccount: "پنُن اکاؤنٹ بنایِو",
    joinTheRide: "وادی سفرس شامل تھاویو", fullName: "پورُ ناو",
    emailOptional: "ای میل (اختیاری)", referralCode: "ریفرل کوڈ (اختیاری)",
    enterReferralCode: "ریفرل کوڈ درج کرِو", referralBonus: "تہِ تہ تہنز دوست دوشونے ₹100 ملِ!",
    upiTransactionRef: "UPI ٹرانزیکشن ID", bankTransferRef: "بینک ٹرانسفر حوالہ",
    payAfterNote: "ادائیگی بعد ٹرانزیکشن حوالہ درج کرِو۔ ایڈمن تصدیق کرِ۔",
    manageRides: "سواریاں منظم کرِو", addDriver: "ڈرائیور شامل کرِو", pending: "زیرِ التوا",
    activeDrivers: "فعال ڈرائیور", signups: "سائن اَپ",
  }
};

export default translations;
